export const Traffic = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
      <path d="M1.00001 0H13C13.3682 0 13.6667 0.29848 13.6667 0.666667V11.3333C13.6667 11.7015 13.3682 12 13 12H1.00001C0.631824 12 0.333344 11.7015 0.333344 11.3333V0.666667C0.333344 0.29848 0.631824 0 1.00001 0ZM1.66668 1.33333V10.6667H12.3333V1.33333H1.66668ZM7.00001 8H11V9.33333H7.00001V8ZM4.77791 6L2.89229 4.11438L3.8351 3.17157L6.66354 6L3.8351 8.8284L2.89229 7.8856L4.77791 6Z" fill="white"/>
    </svg>
  )
}
